import React, { useEffect, useState } from "react";
import { Button, Accordion } from "react-bootstrap";
import Slider from "react-slick";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Header from "../../../../containers/Header";
import { useNavigate, useLocation, useParams } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";
import LeftBarSports from "../../../components/LeftBarSports.js";

import BeforeLoginFooter from "../../../../containers/BeforeLoginFooter";
import Footer from "../../../../containers/Footer";
import { getBanners } from "../../../../redux/app/actions";

import { casinoTabs } from "../../../../lib/data";

import play from "../../../../assets/images/play-button.png";

import Inplay from "../../../../assets/images/icons/Inplay.png";
import Cricket from "../../../../assets/images/icons/crickenew.png";
import Soccer from "../../../../assets/images/icons/soccernew.png";
import Tennis from "../../../../assets/images/icons/tennisnew.png";

import PostsComponent from "../bonus/posts/index.js";
import { postData } from "../../../../lib/data/bonus.data.js";

import Andarbahr from "../../../../assets/images/Ezugi/Andarbahr.jpg";
import DragonTiger from "../../../../assets/images/Ezugi/DragonTiger.jpg";
import Lucky7 from "../../../../assets/images/Ezugi/Lucky7.jpg";
import NamasteRoulette1 from "../../../../assets/images/Ezugi/NamasteRoulette.jpg";
import SpeedRoulette1 from "../../../../assets/images/Ezugi/SpeedRoulette.jpg";
import UltimateROulette1 from "../../../../assets/images/Ezugi/UltimateROulette.jpg";

import CashOrCrash from "../../../../assets/images/Evolution/CashOrCrash.jpg";
import CrazyTime from "../../../../assets/images/Evolution/CrazyTime.jpg";
import dreamcatcher from "../../../../assets/images/Evolution/dreamcatcher.jpg";
import FootballStudio from "../../../../assets/images/Evolution/FootballStudio.jpg";
import LightningRoulette from "../../../../assets/images/Evolution/LightningRoulette.jpg";
import Megaball from "../../../../assets/images/Evolution/Megaball.jpg";

import Strike from "../../../../assets/images/SlotsNew/777Strike.jpg";
import asgardianstones from "../../../../assets/images/SlotsNew/asgardianstones.jpg";
import CashUltimate from "../../../../assets/images/SlotsNew/CashUltimate.jpg";
import DynamiteRiches from "../../../../assets/images/SlotsNew/DynamiteRiches.jpg";
import goldencryptex from "../../../../assets/images/SlotsNew/goldencryptex.jpg";
import GrandWheel from "../../../../assets/images/SlotsNew/GrandWheel.jpg";

import Aviator from "../../../../assets/images/spribe/Aviator.jpg";
import Dice from "../../../../assets/images/spribe/Dice.jpg";
import Goal from "../../../../assets/images/spribe/Goal.jpg";
import Hilo from "../../../../assets/images/spribe/Hilo.jpg";
import Mine1 from "../../../../assets/images/spribe/Mine.jpg";
import MiniROulette1 from "../../../../assets/images/spribe/MiniROulette.jpg";

import DragonTiger1 from "../../../../assets/images/Vivo/DragonTiger.jpg";
import FrenchROulette from "../../../../assets/images/Vivo/FrenchROulette.jpg";
import GalaxtBaccarat1 from "../../../../assets/images/Vivo/GalaxtBaccarat1.jpg";
import GalaxyROulette from "../../../../assets/images/Vivo/GalaxyROulette.jpg";
import OracleBlaze from "../../../../assets/images/Vivo/OracleBlaze.jpg";
import TeenPatti11 from "../../../../assets/images/Vivo/TeenPatti.jpg";

import Slide1 from "../../../../assets/images/VSlider/slide1.jpg";
import Slide2 from "../../../../assets/images/VSlider/slide2.jpg";
import Slide3 from "../../../../assets/images/VSlider/slide3.jpg";
import CasinoGame1 from "../../../../assets/images/sidebar-games/casino-game1.jpg";
import CasinoGame2 from "../../../../assets/images/sidebar-games/casino-game2.jpg";
import CasinoGame3 from "../../../../assets/images/sidebar-games/casino-game3.jpg";
import CasinoGame4 from "../../../../assets/images/sidebar-games/casino-game4.jpg";
import CasinoGame5 from "../../../../assets/images/sidebar-games/casino-game5.jpg";

import DragonTigerSupernowa from "../../../../assets/images/supernowa/Dragontiger.jpg";
import GoaAB from "../../../../assets/images/supernowa/goasandarbahar.jpg";
import KingRace from "../../../../assets/images/supernowa/KingRace.jpg";
import worlimatka from "../../../../assets/images/supernowa/worlimatka.jpg";
import ThreePlayerTP from "../../../../assets/images/supernowa/3playersteenpatti.jpg";
import Lucky7SUpernowa from "../../../../assets/images/supernowa/Lucky7.jpg";

import BetbyImg from "../../../../assets/images/Sportsbook.jpg";
import ExchangeImg from "../../../../assets/images/Exchange.jpg";
import ProvidersSlider from "../../../components/ProvidersSlider.js";

import WhatsappIcon from "../../../../assets/images/whatsapp.png";
import TelegramIcon from "../../../../assets/images/Telegran.png";
import InstaIcon from "../../../../assets/images/Instagram.png";
import Facebook from "../../../../assets/images/facebook.png";

const Sports = () => {
  const navigate = useNavigate();
  const { isAuth } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const { appDetails } = useSelector((state) => state.app);
  const params = useParams();
  const category = params?.category;
  // console.log("category", category);
  const location = useLocation();
  const [activeKey, setActiveKey] = useState("1");
  const { sportsData, oddsData, showBetSlip } = useSelector(
    (state) => state.sports
  );
  const { banners } = useSelector((state) => state.app);

  const tabs = [
    {
      id: 1,
      eventKey: "1",
      name: "In play",
      img: <img src={Inplay} />,
      redirectUrl: "inplay",
    },
    {
      id: 2,
      eventKey: "2",
      name: "Cricket",
      img: <img src={Cricket} />,
      redirectUrl: "cricket",
    },
    {
      id: 3,
      eventKey: "3",
      name: "Soccer",
      img: <img src={Soccer} />,
      redirectUrl: "soccer",
    },
    {
      id: 4,
      eventKey: "4",
      name: "Tennis",
      img: <img src={Tennis} />,
      redirectUrl: "tennis",
    },
  ];

  useEffect(() => {
    dispatch(getBanners());
    // sportsSocket.on("markets", (data) => {
    //   console.log("data", data);
    //   dispatch(setSportsData(data.markets));
    // });
    // sportsSocket.on("marketodds", (data) => {
    //   console.log("data", data);
    //   console.log("data", data);
    //   dispatch(setOddsData(data.marketOdds));
    // });
    // return () => {
    //   sportsSocket.off();
    // };
  }, []);

  // useEffect(() => {
  //   if (location?.state?.selectedTab) {
  //     console.log("location?.state?.selectedTab", location?.state?.selectedTab);
  //     setActiveKey(location.state.selectedTab);
  //   }
  // }, [location]);

  useEffect(() => {
    if (category && location?.state?.selectedTab) {
      setActiveKey(location.state.selectedTab);
    }
  }, [category, location]);

  const handleEventClick = (event) => {
    navigate(
      `/detail-page/${event?.marketSlug}/${event?.matchid}/${event?.marketid}/${event?.SportId}`
    );
  };

  const handleBetSlip = (value) => {
    //dispatch(showbetSlip(value));
  };

  const handleBetSlipContent = (data) => {
    // dispatch(betSlipContent(data));
  };

  const settings = {
    arrows: true,
    dots: false,
    swipeToSlide: true,
    infinite: true,
    autoplay: true,
    slidesToShow: 2,
    slidesToScroll: 1,

    speed: 7000,
    responsive: [
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          arrows: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          arrows: true,
        },
      },
    ],
  };

  const handleTabClick = (event) => {
    const s = tabs.find(({ eventKey }) => eventKey === event);
    if (s) {
      setActiveKey(event);
      if (isAuth) {
        navigate(`/sportsbook/${s.redirectUrl}`);
      } else {
        navigate(`/sports/${s.redirectUrl}`);
      }
    }
  };
  const getMatchLength = (eventKey) => {
    switch (eventKey) {
      case "1":
        let tempArr = [];
        sportsData?.map((s) => {
          s?.values?.map((v) => {
            if (new Date(v?.matchdate) <= new Date()) {
              tempArr.push(v);
            }
          });
        });
        return tempArr.length;
      case "2":
        return (
          sportsData?.find(({ sportname }) => sportname === "Cricket")?.values
            ?.length || 0
        );
      case "3":
        return sportsData?.find(({ sportname }) => sportname === "Soccer")
          ?.values?.length;
      case "4":
        return sportsData?.find(({ sportname }) => sportname === "Tennis")
          ?.values?.length;
      default:
        return 0;
    }
  };

  return (
    <>
      {isAuth ? <HeaderAfterLogin /> : <Header />}
      <main className="main d-flex matchlistpage">
        <LeftBarSports />

        <div className="middleContentSec">
          <div className="sports_page_banner">
            <Slider {...settings}>
              {banners &&
                banners.length > 0 &&
                banners.map((b, index) => {
                  return (
                    <div key={index} className="position-relative">
                      <img
                        src={b.link}
                        alt="Fourth Slide"
                        // style={{ aspectRatio: "16/9", objectFit: "fill" }}
                      />
                      <div className="banner-btn">
                        {(b?.ctabtns.length &&
                          b?.ctabtns.map((btn, idx) => (
                            <Button
                              key={idx}
                              onClick={() =>
                                (window.location.href = btn.actionLink)
                              }
                            >
                              {btn?.label}
                            </Button>
                          ))) ||
                          null}
                      </div>
                    </div>
                  );
                })}
            </Slider>
          </div>

          <div className="leftMiddleSec">
            <div className="providers">
              <h4>Casinos</h4>

              <ProvidersSlider />
            </div>

            <div className="GamesSection">
              <h4>Popular Games</h4>
              <ul>
                {Object.values(casinoTabs?.popularGames).map((game, idx) => {
                  return (
                    <li key={idx}>
                      <a href={game?.redirectUrl}>
                        <img src={game?.imgUrl} />
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>

            <div className="providers d-flex d-md-none mt-4">
              <h4>Sports</h4>
              <div className="games">
                <a href="/betby">
                  <img src={BetbyImg} alt="First Slide" />
                  <img src={play} className="play_button" />
                  <p>Sportsbook </p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/sports">
                  <img src={ExchangeImg} alt="Second Slide" />
                  <img src={play} className="play_button" />
                  <p>Exchange</p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
            </div>

            <div className="providers d-flex d-md-none mt-4">
              <h4>Hot Games</h4>
              <div className="games">
                <a href="/casino/ezugi/SpeedRoulette">
                  <img src={Slide1} alt="First Slide" />
                  <img src={play} className="play_button" />
                  <p>Speed Roulette </p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/ezg-cricket-war">
                  <img src={Slide2} alt="Second Slide" />
                  <img src={play} className="play_button" />
                  <p>Cricket War </p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/ezg-sic-bo">
                  <img src={Slide3} alt="Thired Slide" />
                  <img src={play} className="play_button" />
                  <p>Sicbo </p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/ezg-baccarat">
                  <img src={CasinoGame2} alt="Casino Game" />
                  <img src={play} className="play_button" />
                  <p>Baccarat </p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/betby">
                  <img src={CasinoGame1} alt="Casino Game" />
                  <img src={play} className="play_button" />
                  <p>Sportsbook </p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/ezg-andar-bahar">
                  <img src={CasinoGame3} alt="Casino Game" />
                  <img src={play} className="play_button" />
                  <p>Andar Bahar </p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/ezg-dragon-tiger">
                  <img src={CasinoGame4} alt="Casino Game" />
                  <img src={play} className="play_button" />
                  <p>Dragon Tiger </p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/ezg-lucky-7">
                  <img src={CasinoGame5} alt="Casino Game" />
                  <img src={play} className="play_button" />
                  <p>Lucky 7 </p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
            </div>
            <div className="providers  d-md-none NewProviders  mt-4">
              <h4 className="d-flex justify-content-between">
                Ezugi <Button href="/casino/ezugi">See All</Button>
              </h4>
              <div className="games">
                <a href="/casino/ezg-andar-bahar">
                  <img src={Andarbahr} alt="ezugi" />
                  <img src={play} className="play_button" />
                  <p>Andar Bahar</p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/ezg-dragon-tiger">
                  <img src={DragonTiger} alt="evolution" />
                  <img src={play} className="play_button" />
                  <p>Dragon Tiger</p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/ezg-lucky-7">
                  <img src={Lucky7} alt="vivo" />
                  <img src={play} className="play_button" />
                  <p>Lucky 7 </p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/ezg-namaste-roulette">
                  <img src={NamasteRoulette1} alt="slots" />
                  <img src={play} className="play_button" />
                  <p>Namaste Roulette</p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/ezg-speed-roulette">
                  <img src={SpeedRoulette1} alt="supernowa" />
                  <img src={play} className="play_button" />
                  <p>Speed Roulette</p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a
                  href="#"
                  onClick={() => {
                    navigate(
                      isAuth
                        ? "/casino/ezg-ultimate-roulette"
                        : "/casino/ezg-ultimate-roulette"
                    );
                  }}
                >
                  <img src={UltimateROulette1} alt="sports" />
                  <img src={play} className="play_button" />
                  <p>Ultimate Roulette </p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
            </div>
            <div className="providers  d-md-none NewProviders mt-4">
              <h4 className="d-flex justify-content-between">
                Evolution <Button href="/casino/evolution">See All</Button>
              </h4>
              <div className="games">
                <a href="/casino/ezgevo-cash-or-crash">
                  <img src={CashOrCrash} alt="ezugi" />
                  <img src={play} className="play_button" />
                  <p>Cash Or Crash</p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/ezgevo-crazy-time">
                  <img src={CrazyTime} alt="evolution" />
                  <img src={play} className="play_button" />
                  <p>Crazy Time</p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/ezgevo-mega-ball">
                  <img src={Megaball} alt="vivo" />
                  <img src={play} className="play_button" />
                  <p>Mega ball </p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/ezgevo-dream-catcher">
                  <img src={dreamcatcher} alt="slots" />
                  <img src={play} className="play_button" />
                  <p>Dream catcher</p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/ezgevo-football-studio">
                  <img src={FootballStudio} alt="supernowa" />
                  <img src={play} className="play_button" />
                  <p>Football Studio</p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a
                  href="#"
                  onClick={() => {
                    navigate(
                      isAuth
                        ? "/casino/ezgevo-lightning-roulette"
                        : "/casino/ezgevo-lightning-roulette"
                    );
                  }}
                >
                  <img src={LightningRoulette} alt="sports" />
                  <img src={play} className="play_button" />
                  <p>Lightning Roulette </p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
            </div>

            <div className="providers d-none">
              <h4 className="d-flex justify-content-between">
                Supernowa <Button href="/casino/evolution">See All</Button>
              </h4>
              <div className="games">
                <a href="/casino/sn-dragon-tiger">
                  <img src={DragonTigerSupernowa} alt="ezugi" />
                  <img src={play} className="play_button" />
                  <p>Dragon Tiger</p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/sn-goas-andar-bahar">
                  <img src={GoaAB} alt="evolution" />
                  <img src={play} className="play_button" />
                  <p>Goa's Andar Bahar</p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/sn-king-race">
                  <img src={KingRace} alt="vivo" />
                  <img src={play} className="play_button" />
                  <p>King Race </p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/sn-worli-matka">
                  <img src={worlimatka} alt="slots" />
                  <img src={play} className="play_button" />
                  <p> Worli Matka</p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/sn-3-player-teenpatti">
                  <img src={ThreePlayerTP} alt="supernowa" />
                  <img src={play} className="play_button" />
                  <p>Three Player Teen Patti</p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a
                  href="#"
                  onClick={() => {
                    navigate(
                      isAuth ? "/casino/sn-lucky-7e" : "/casino/sn-lucky-7e"
                    );
                  }}
                >
                  <img src={Lucky7SUpernowa} alt="sports" />
                  <img src={play} className="play_button" />
                  <p>Lucky7 </p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
            </div>

            <div className="providers  d-md-none NewProviders mt-4">
              <h4 className="d-flex justify-content-between">
                Slots <Button href="/Slots">See All</Button>
              </h4>
              <div className="games">
                <a href="/casino/ezgrt-777-strike">
                  <img src={Strike} alt="ezugi" />
                  <img src={play} className="play_button" />
                  <p>777 Strike</p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/ezgne-asgardian-stones">
                  <img src={asgardianstones} alt="evolution" />
                  <img src={play} className="play_button" />
                  <p>Asgardian Stones</p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/ezgrt-cash-ultimate">
                  <img src={CashUltimate} alt="vivo" />
                  <img src={play} className="play_button" />
                  <p>Cash Ultimate </p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/ezgrt-dynamite-riches">
                  <img src={DynamiteRiches} alt="slots" />
                  <img src={play} className="play_button" />
                  <p>Dynamite Riches</p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/ezgrt-golden-cryptex">
                  <img src={goldencryptex} alt="supernowa" />
                  <img src={play} className="play_button" />
                  <p>Goldencryptex</p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a
                  href="#"
                  onClick={() => {
                    navigate(
                      isAuth
                        ? "/casino/ezgrt-grand-wheel"
                        : "/casino/ezgrt-grand-wheel"
                    );
                  }}
                >
                  <img src={GrandWheel} alt="sports" />
                  <img src={play} className="play_button" />
                  <p>GrandWheel </p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
            </div>
            <div className="providers  d-md-none  NewProviders mt-4">
              <h4 className="d-flex justify-content-between">
                Spribe <Button href="/spribe">See All</Button>
              </h4>

              <div className="games">
                <a href="/casino/spribe/aviator">
                  <img src={Aviator} alt="ezugi" />
                  <img src={play} className="play_button" />
                  <p>Aviator</p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/spribe/dice">
                  <img src={Dice} alt="evolution" />
                  <img src={play} className="play_button" />
                  <p>Dice</p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/spribeg/oal">
                  <img src={Goal} alt="vivo" />
                  <img src={play} className="play_button" />
                  <p>Goal </p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/spribe/hilo">
                  <img src={Hilo} alt="slots" />
                  <img src={play} className="play_button" />
                  <p>Hilo</p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/spribe/mines">
                  <img src={Mine1} alt="supernowa" />
                  <img src={play} className="play_button" />
                  <p>Mine</p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a
                  href="#"
                  onClick={() => {
                    navigate(
                      isAuth
                        ? "/casino/spribe/miniroulette"
                        : "/casino/spribe/miniroulette"
                    );
                  }}
                >
                  <img src={MiniROulette1} alt="sports" />
                  <img src={play} className="play_button" />
                  <p>Mini Roulette </p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
            </div>
            <div className="providers  d-md-none  NewProviders mt-4">
              <h4 className="d-flex justify-content-between">
                Vivo <Button href="/casino/vivo">See All</Button>
              </h4>
              <div className="games">
                <a href="/casino/vivo-dragon-tiger">
                  <img src={DragonTiger1} alt="ezugi" />
                  <img src={play} className="play_button" />
                  <p>Dragon Tiger</p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/vivo-french-roulette">
                  <img src={FrenchROulette} alt="evolution" />
                  <img src={play} className="play_button" />
                  <p>French Roulette</p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/vivo-galaxy-baccarat-1">
                  <img src={GalaxtBaccarat1} alt="vivo" />
                  <img src={play} className="play_button" />
                  <p>Galaxy Baccarat</p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/vivo-galaxy-roulette">
                  <img src={GalaxyROulette} alt="slots" />
                  <img src={play} className="play_button" />
                  <p>Galaxy Roulette</p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a href="/casino/spribe-mines">
                  <img src={OracleBlaze} alt="supernowa" />
                  <img src={play} className="play_button" />
                  <p>Oracle Blaze</p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
              <div className="games">
                <a
                  href="#"
                  onClick={() => {
                    navigate(
                      isAuth
                        ? "/casino/vivo-teen-patti"
                        : "/casino/vivo-teen-patti"
                    );
                  }}
                >
                  <img src={TeenPatti11} alt="sports" />
                  <img src={play} className="play_button" />
                  <p>Teen Patti </p>
                </a>
                <span className="focus-border">
                  <i></i>
                </span>
              </div>
            </div>

            <div className="promotions mt-4">
              <h4>Promotions</h4>
              <PostsComponent data={postData} />
            </div>

            <div className="FAQWrapper">
              <div className="promotiion-content">
                {/* <h4>Frequently Asked Questions</h4> */}
                <Accordion>
                  <Accordion.Item eventKey="10">
                    <Accordion.Header>
                      Frequently Asked Questions
                    </Accordion.Header>
                    <Accordion.Body>
                      <Accordion className="mb-3">
                        <Accordion.Item eventKey="4">
                          <Accordion.Header>
                            Does Live Casino have real dealers?
                          </Accordion.Header>
                          <Accordion.Body>
                            {/* <div className="promotionimg">
                        <img src={DepositImgPromotion} />
                      </div> */}

                            <p>
                              Live Casino is an exciting new way to play your
                              favourite table games. You can enjoy Live
                              Blackjack, Live Baccarat, Live Infinite Blackjack,
                              Live Ultimate Texas Hold'em, Live Baccarat
                              eSqueeze, Live Roulette, and Live Auto Roulette
                              streamed in real-time video, delivering an
                              authentic gambling experience where real dealers
                              shuffle, deal and interact with players, just like
                              in a real casino.
                            </p>

                            <p>
                              Live Casino game outcomes are determined with real
                              cards whereas other table games on Dial4bet use a
                              random number generator to determine game
                              outcomes.
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                      <Accordion className="mb-3">
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>
                            How do I play Live Casino?
                          </Accordion.Header>
                          <Accordion.Body>
                            <div className="promotionimg">
                              {/* <img src={DepositImgPromotion} /> */}
                            </div>

                            <p>
                              Clicking on any of the Live Casino game tiles will
                              launch Live Casino in a new pop up window. You can
                              watch on any game table without sitting down or
                              placing a bet, so feel free to open it and look
                              around!
                            </p>
                            <p>
                              Alternatively, demo videos of betting on each of
                              the game types are available here.
                            </p>
                            <p>
                              To place a bet, pick your game type and/or table.
                              If you selected Blackjack, pick an available
                              (green) seat at the table. Select a chip value,
                              then select a betting spot, and your bet is
                              placed. Now the game plays out and your bet is
                              settled based on the game outcome.
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                      <Accordion className="mb-3">
                        <Accordion.Item eventKey="1">
                          <Accordion.Header>
                            What if I have a Live Casino issue?
                          </Accordion.Header>
                          <Accordion.Body>
                            <div className="promotionimg">
                              {/* <img src={FirstDepositImgPromotion} /> */}
                            </div>
                            <p>
                              If you have an issue, we can help several ways.
                              Live Casino has a chat function that allows you to
                              chat with your dealer or the Live Casino customer
                              support staff to notify them of your issue.
                            </p>
                            <p>
                              If you have an issue not related to Live Casino,
                              with depositing for example, contact Dial4bet
                              Customer Support through chat, email or phone,
                              details here
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                      <Accordion className="mb-3">
                        <Accordion.Item eventKey="2">
                          <Accordion.Header>
                            When is the Live Casino studio open or closed?
                          </Accordion.Header>
                          <Accordion.Body>
                            <div className="promotionimg">
                              {/* <img src={SecondDepositImgPromotion} /> */}
                            </div>
                            <p>
                              The Live Casino studio is open 24 hours per day.
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                      <Accordion className="mb-3">
                        <Accordion.Item eventKey="3">
                          <Accordion.Header>
                            What are the system requirements for Live Casino?
                          </Accordion.Header>
                          <Accordion.Body>
                            <div className="promotionimg"></div>
                            <p>
                              Always use the most up-to-date version of your
                              browser to ensure a good Live Casino experience.
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                      <Accordion className="mb-3">
                        <Accordion.Item eventKey="5">
                          <Accordion.Header>
                            Why can’t I launch Live Casino?
                          </Accordion.Header>
                          <Accordion.Body>
                            <div className="promotionimg"></div>
                            <p>
                              If you can’t launch Live Casino, your Flash player
                              may be blocked. This help article from Adobe, the
                              makers of Flash, provides browser specific
                              troubleshooting info.
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                      <Accordion className="mb-3">
                        <Accordion.Item eventKey="6">
                          <Accordion.Header>
                            Why does my Live Casino balance not update
                            automatically?
                          </Accordion.Header>
                          <Accordion.Body>
                            <div className="promotionimg"></div>
                            <p>
                              The Live Casino balance updates each time it
                              connects with the Dial4bet server but these two
                              systems are not always connected. For example, if
                              you deposit money to your Dial4bet account while
                              the Live Casino client is open, you will not see
                              your balance update in the Live Casino client
                              until an event occurs that requires the client to
                              contact the Dial4bet server. Here are some
                              examples of events that require the two servers to
                              connect: launching the Live Casino client; opening
                              a table; making a wager; settling a wager.
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>
          </div>

          <div className="payment-info social">
            <div className="social-icons">
              <ul>
                <li>
                  <a
                    className="panel"
                    href={
                      appDetails?.TELEGRAM != "" ? appDetails?.TELEGRAM : "#"
                    }
                    target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
                  >
                    <img src={TelegramIcon} alt="Telegram Icon" />
                    <p>Telegram</p>
                  </a>
                </li>
                <li>
                  <a
                    className="panel"
                    href={
                      appDetails?.INSTAGRAM != "" ? appDetails?.INSTAGRAM : "#"
                    }
                    target={appDetails?.INSTAGRAM != "" ? "_blank" : ""}
                  >
                    <img src={InstaIcon} alt="Instagram Icon" />
                    <p>Instagram</p>
                  </a>
                </li>
                {/* <li>
                  <a target="_blank">
                    <img src={EmailIcon} alt="Email Icon" />
                    <p>
                      Email <span>24/7</span>
                    </p>
                  </a>
                </li> */}
                <li>
                  <a
                    href={
                      appDetails?.FACEBOOK != "" ? appDetails?.FACEBOOK : "#"
                    }
                    target={appDetails?.FACEBOOK != "" ? "_blank" : ""}
                  >
                    <img src={Facebook} alt="Email Icon" />
                    <p>Facebook</p>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="wtsp-chat" id="wtsp-chat">
            <a
              href={
                appDetails?.WHATS_APP_URL != ""
                  ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                  : "javascript:void(0)"
              }
              target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
            >
              <img src={WhatsappIcon} alt="whatsapp" />
            </a>
          </div>

          {/* <RightBarCasino /> */}

          {!isAuth ? <BeforeLoginFooter /> : <Footer />}
        </div>
      </main>

      {/* {showBetSlip && (
        <BetSlip
          handleClose={() => {
            handleBetSlip(false);
          }}
        />
      )} */}
    </>
  );
};

export default Sports;
